export const academyTemplates = [
  "Spider-Man",
  "Black Panther",
  "Doctor Strange",
  "Daredevil",
  "Hawkeye",
  "Scarlet Witch",
  "Wolverine",
  "Deadpool",
  "Captain Marvel",
  "Ant Man",
  "Iron Man",
  "Hulk",
  "Captain America",
  "Thor",
] as const;

export const otherTemplates = [
  "azurill",
  "bronzor",
  "chikorita",
  "ditto",
  "gengar",
  "glalie",
  "kakuna",
  "leafish",
  "nosepass",
  "onyx",
  "pikachu",
  "rhyhorn",
] as const;

export const templatesList = [...academyTemplates, ...otherTemplates] as const;

export type Template = (typeof templatesList)[number];

export const templateGroups = [
  {
    name: "AcadéNice",
    templates: academyTemplates,
  },
  {
    name: "Autres",
    templates: otherTemplates,
  },
] as const;

export const previewTemplatesList = ["Example", ...templatesList] as const;

export type Preview = (typeof previewTemplatesList)[number];
